import styled from '@emotion/styled'
import dynamic from 'next/dynamic'
import { replaceAll } from '../lib/strings'

const JoditEditor = dynamic(() => import('jodit-react'), {
  ssr: false,
})

const joditConfig = {
  spellcheck: false,
  direction: 'ltr',
  toolbarAdaptive: false,
  toolbarSticky: false,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  defaultActionOnPaste: 'insert_only_text',
  disablePlugins:
    'fullsize,iframe,imageproperties,imageprocessor,inlinepopup,justify,orderedlist,redoundo,resizer,search,stat,tablekeyboardnavigation,table,xpath,source,font',
  buttons: 'link,bold,italic,underline',
  colorPickerDefaultTab: 'text',
  removeEmptyBlocks: true,
  removeEmptyNodes: true,
  link: {
    noFollowCheckbox: false,
    openInNewTabCheckbox: false,
  },
}

const Container = styled.div`
  .jodit_container .jodit_toolbar,
  .jodit_container .jodit_statusbar {
    background-color: ${({ theme }) => theme.colors.background};
  }

  .jodit_container {
    border-width: 0.125rem;
    border-radius: 0.125rem;
    border-color: ${({ theme }) => theme.colors.background};
    border-style: solid;
  }

  .jodit_container:not(.jodit_inline) .jodit_workplace {
    border: 0;
    font-family: Inter UI, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
      Helvetica, Arial, sans-serif;
    font-size: 0.875rem;
    line-height: 1.5;
  }

  .jodit_toolbar {
    background: transparent;
    border-color: ${({ theme }) => theme.colors.background};
    border-width: 0 0 1px 0;
  }

  .jodit-ui-button_variant_primary,
  .jodit_link_insert_button,
  .jodit_unlink_button {
    background-color: ${({ theme }) => theme.colors.gray};
    color: ${({ theme }) => theme.colors.background};
    border-style: none;
    border-radius: 0.125rem;
    border-width: 0;
    margin: 0;

    &:hover {
      color: ${({ theme }) => theme.colors.background};
    }
  }

  .jodit-wysiwyg {
    p {
      margin-top: 0;
    }
  }
`

const Label = styled.label`
  display: inline-block;
  font-size: 0.875rem;
  font-weight: 500;
`

const RichTextInput = ({
  className,
  label,
  name,
  onChange,
  placeholder,
  value,
}) => {
  const handleBlur = (newContent) => {
    let treatedValue = newContent
    treatedValue = replaceAll(
      treatedValue,
      'rel="noopener noreferrer" target="_blank" href=',
      'href='
    )
    treatedValue = replaceAll(
      treatedValue,
      'href=',
      'rel="noopener noreferrer" target="_blank" href='
    )
    treatedValue = replaceAll(treatedValue, '<p><br></p>', '')
    onChange(treatedValue)
  }

  return (
    <Container className={className}>
      {label && (
        <Label className="mb2" htmlFor={name}>
          {label}
        </Label>
      )}
      <JoditEditor
        value={value || ''}
        config={{ placeholder, ...joditConfig }}
        onBlur={handleBlur}
      />
    </Container>
  )
}

export default RichTextInput
